import {AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Subscription } from 'rxjs';
import { Advertiser } from '../../../core/models/advertiser';
import { Brand } from '../../../core/models/brand';
import { IntegrationDao } from '../../../core/services/dao/integrationDao';
import { ErrorDialogService } from '../errorDialog/errorDialogService';
import { AmazonComponent } from './amazon/amazon.component';
import { FacebookComponent } from './facebook/facebook.component';
import { GoogleAdsComponent } from './google-ads/google-ads.component';
import { GoogleAnalyticsReportingComponent } from './google-analytics-reporting/google-analytics-reporting.component';
import { GoogleAnalyticsComponent } from './google-analytics/google-analytics.component';
import { SnapchatComponent } from './snapchat/snapchat.component';
import { TwitterComponent } from './twitter/twitter.component';
import { BingComponent } from './bing/bing.component';
import { AgencyDao } from '../../../core/services/dao/agencyDao';
import { Agency } from '../../../core/models/agency';
import { TradeDeskComponent } from './trade-desk/trade-desk.component';
import { UserDao } from '../../../core/services/dao/userDao';
import { GoogleDriveComponent } from './google-drive/google-drive.component';
import { S3Component } from './s3/s3.component';
import { EventEmitter } from '@angular/core';
import { User } from '../../../core/models/user';
import { IntegrationInvite } from '../../../core/models/integrationInvite';
import { IntegrationInviteDao } from '../../../core/services/dao/integrationInviteDao';
import { TrackingTagComponent } from './tracking-tag/tracking-tag.component';
import { TraaqrTag } from '../../../core/models/traaqrTag';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import {Integration} from "../../../core/models/integration";
import {GoogleAdsReadOnlyComponent} from "./google-ads-read-only/google-ads-read-only.component";
import {FtpComponent} from "./ftp/ftp.component";

interface IIntegrationDisplay {
  name: string;
  category: string;
  type: string;
  img: string;
  click: any;
  clickEdit?: any;
  description: string;
  helplink: string;
  connected?: boolean;
  editable?: boolean;
  editText?: string;
  data?: any;
  includeSubHeader: boolean;
  subHeader?: string;
  connectedIntegrations?: any[]
}

@Component({
  selector: 'shared-integrations',
  templateUrl: './shared-integrations.component.html',
  styleUrls: ['./shared-integrations.component.scss']
})
export class SharedIntegrationsComponent implements OnInit, OnDestroy, OnChanges {
  /// todo find web tracking link
  integrations: IIntegrationDisplay[] = [
    {
      name: 'Tracking Tag',
      category: 'tracking',
      type: 'web_tracking',
      img: '../../../assets/image/advocado_inline_full_color.png',
      click: this.webTracking.bind(this),
      helplink: '',
      description: 'Lorem Ipsum',
      connectedIntegrations: [],
      includeSubHeader: true,
      subHeader: 'Tracking Tag'
    },
    // {
    //   name: 'Google Analytics - Events',
    //   category: 'analytics',
    //   type: 'google_analytics',
    //   img: '../../../assets/image/google_analytics-events.svg',
    //   click: this.googleAnalytics.bind(this),
    //   helplink: 'https://www.myadvocado.com/help/how-to-connect-google-analytics-with-advocado',
    //   description:
    //     'When Events are connected, Advocado will send tracking events to the provided Google Analytics Tracking ID.',
    //   connectedIntegrations: [],
    //   includeSubHeader: false
    // },
    // {
    //   name: 'Google Analytics - Reporting',
    //   category: 'analytics',
    //   type: 'google_analytics_reporting',
    //   img: '../../../assets/image/google_analytics-reporting.svg',
    //   click: this.googleAnalyticsReporting.bind(this),
    //   helplink: 'https://www.myadvocado.com/help/google-analytics-reporting-integration',
    //   description:
    //     'Connecting the Advocado Reporting Integration for your Google Analytics account allows Advocado to receive analytics ' +
    //     'data from your account. This enables features like your ability to compare Advocado performance data to your Google ' +
    //     'Analytics data.',
    //   connectedIntegrations: [],
    //   includeSubHeader: false
    // },
    {
      name: 'Google Ads',
      category: 'adPlatform',
      type: 'google_ads',
      img: '../../../assets/image/google-ads.svg',
      click: this.googleAds.bind(this),
      helplink: 'https://www.myadvocado.com/help/google-ads-integration',
      description:
        'Connecting Advocado to your Google Ads accounts allows Advocado to activate and adjust second screen campaigns in real time.',
      connectedIntegrations: [],
      includeSubHeader: false
    },
    {
      name: 'Google Ads (Read Only)',
      category: 'adPlatform',
      type: 'google_ads_read_only',
      img: '../../../assets/image/google-ads.svg',
      click: this.googleAdsReadOnly.bind(this),
      helplink: 'https://www.myadvocado.com/help/google-ads-integration',
      description:
        'Connecting to your Google Ads accounts allows Advocado to provide improved attribution.',
      connectedIntegrations: [],
      includeSubHeader: true,
      subHeader: "(Read Only)"
    },
    {
      name: 'Facebook',
      category: 'adPlatform',
      type: 'facebook',
      img: '../../../assets/image/facebook.svg',
      click: this.facebook.bind(this),
      helplink: 'http://www.myadvocado.com/help/facebook-activate-set-up',
      description: 'Connect Facebook to enable Advocado Activate real time adjustments on Facebook Ads',
      connectedIntegrations: [],
      includeSubHeader: false
    },
    {
      name: 'Amazon',
      category: 'adPlatform',
      type: 'amazon',
      img: '../../../assets/image/amazon-logo.svg',
      click: this.amazon.bind(this),
      helplink: 'https://www.myadvocado.com/help/amazon-integration',
      description:
        'Connect your Amazon Seller Central account to enable Advocado Activate to make real time bidding adjustments on Amazon Ads.',
      connectedIntegrations: [],
      includeSubHeader: false
    },
    {
      name: 'Twitter',
      category: 'adPlatform',
      type: 'twitter',
      img: '../../../assets/image/twitter-logo.svg',
      click: this.twitter.bind(this),
      helplink: 'https://www.myadvocado.com/help/twitter-integration',
      description: 'Connect Twitter to enable Advocado Activate real time bid adjustments on Twitter Ads',
      connectedIntegrations: [],
      includeSubHeader: true,
      subHeader: 'Twitter'
    },
    {
      name: 'Snapchat',
      category: 'adPlatform',
      type: 'snapchat',
      img: '../../../assets/image/snap-logo.svg',
      click: this.snapchat.bind(this),
      helplink: 'https://www.myadvocado.com/help/snapchat-integration',
      description: 'Connect Snapchat to enable Advocado Activate real time bid adjustments on Snapchat Ads',
      connectedIntegrations: [],
      includeSubHeader: true,
      subHeader: 'Snapchat'
    },
    {
      name: 'Bing Ads',
      category: 'adPlatform',
      type: 'bing',
      img: '../../../assets/image/Bing_Ads_logo.svg',
      click: this.bing.bind(this),
      helplink: 'https://www.myadvocado.com/help/bing-integration',
      description:
        'Connecting Advocado to your Google Ads accounts allows Advocado to activate and adjust second screen campaigns in real time.',
      connectedIntegrations: [],
      includeSubHeader: false
    },
    {
      name: 'Google Drive',
      category: 'adPlatform',
      type: 'google_drive',
      img: '../../../assets/image/google-drive-logo.svg',
      click: this.googleDrive.bind(this),
      helplink: 'https://www.myadvocado.com/help/google-drive-integration',
      description: 'Authenticate with Google to all Avocado to write reports directly to your Google Drive.',
      connectedIntegrations: [],
      includeSubHeader: true,
      subHeader: 'Google Drive'
    },
    {
      name: 'Amazon S3',
      category: 'adPlatform',
      type: 's3',
      img: '../../../assets/image/s3-logo.svg',
      click: this.s3.bind(this),
      helplink: 'https://www.myadvocado.com/help/s3-integration',
      description: 'Connect Amazon S3 to enable Advocado report delivery',
      connectedIntegrations: [],
      includeSubHeader: true,
      subHeader: 'Amazon S3'
    },
    {
      name: 'FTP',
      category: 'dataDestination',
      type: 'ftp',
      img: '../../../assets/image/ftp.svg',
      click: this.ftp.bind(this),
      helplink: 'https://www.myadvocado.com/help/ftp-integration',
      description: 'Connect FTP to enable Advocado report delivery',
      connectedIntegrations: [],
      includeSubHeader: true,
      subHeader: 'Advocado FTP'
    }
  ];

  private ttdIntegration = {
    name: 'The Trade Desk',
    category: 'adPlatform',
    type: 'trade-desk',
    img: '../../../assets/image/the-trade-desk.svg',
    click: this.tradeDesk.bind(this),
    helplink: 'https://www.myadvocado.com/help/trade-desk-integration',
    description: 'Connect The Trade Desk to enable Advocado Activate real time bid adjustments on The Trade Desk',
    connectedIntegrations: [],
    includeSubHeader: false
  };

  @Input() brand: Brand;

  @Input() advertiser: Advertiser;

  @Input() onboardingView: boolean = false;

  @Input() category: string = '';

  @Output() onInviteClick = new EventEmitter<any>();

  @Output() onManageClick = new EventEmitter<any>();

  @Input() tag: TraaqrTag;

  private agency: Agency;

  private _availableIntegrations: Array<string> = [...this.integrations.map(i => i.type), 'trade-desk'];

  @Input()
  set availableIntegrations(temp: Array<string>) {
    this._availableIntegrations = temp;
    this.filterChange();
  }
  get availableIntegrations(): Array<string> {
    return this._availableIntegrations;
  }

  filteredIntegrations: Array<IIntegrationDisplay> = [];

  private subs: Array<Subscription> = [];

  isAdmin = false;

  user: User;
  integrationInvites: IntegrationInvite[] = [];
  @Input() anonIntInvite: IntegrationInvite;
  inviteEmitter = new EventEmitter<any>();
  selectedIntegration: any;
  manageSelected = false;
  invitesInitialized = false;

  constructor(
    public dialog: MatDialog,
    public agencyDao: AgencyDao,
    public userDao: UserDao,
    public errorDialog: ErrorDialogService,
    private integrationDao: IntegrationDao,
    private inviteDao: IntegrationInviteDao,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.user = this.userDao.getCurrentUser();
    if (this.user) {
      this.isAdmin = this.user.isAdmin;
    } else {
      this.isAdmin = false;
    }
    let sub = this.inviteEmitter.subscribe(type => {
      this.selectedIntegration = this.integrations.find(i => i.type === type);
      this.manageSelected = true;
    });
    this.subs.push(sub);
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('tag')) {
      if (!!changes.tag.currentValue) {
        this.integrations.find(i => i.type === 'web_tracking').helplink = `/manage/tags/installation/${this.tag.token}`;
      }
    }
  }

  onBackClick() {
    this.manageSelected = false;
  }

  initInvites() {
    if (this.user && this.brand) {
      // let sub = this.inviteDao.loadByBrand(this.brand.id).subscribe(
      //   invites => {
      //     this.integrationInvites = invites;
      //     let params = this.activatedRoute.snapshot.queryParams;
      //     if (params && params['dialog']) {
      //       let found = this.integrations.find(i => i.type === params['dialog']);
      //       found.click(found.connectedIntegrations, found.description, found.name, found.type);
      //     }
      //     this.invitesInitialized = true;
      //   },
      //   err => {
      //     console.error('error getting integration invites', err);
      //   }
      // );
      // this.subs.push(sub);
    } else {
      this.integrationInvites = [this.anonIntInvite];
      let params = this.activatedRoute.snapshot.queryParams;
      if (params && params['dialog']) {
        let found = this.integrations.find(i => i.type === params['dialog']);
        found.click(found.connectedIntegrations, found.description, found.name, found.type);
      }
      this.invitesInitialized = true;
    }
  }

  integrationHasInvite(int: IIntegrationDisplay) {
    if (int.type === 'web_tracking') return false;
    return !!this.integrationInvites.find(invite => {
      if (invite) {
        return invite.integrations.includes(int.type);
      } else {
        return false;
      }
    })
  }

  integrationConnected(int: IIntegrationDisplay) {
    return int.connectedIntegrations.length > 0;
  }

  //This exists just so that google ads read only's sub header appears correctly
  subHeaderAndConnected(int): boolean {
    return int.subHeader && (this.integrationHasInvite(int) || this.integrationConnected(int)) && this.integrationConnected(int) && int.type === 'google_ads_read_only';
  }


  init() {
    //Don't remove this set timeout, it delays the init 1 cycle so the changes that happen in the parent component
    //have propagated
    setTimeout(() => {
      if (this.advertiser.agency) {
        // let sub = this.integrationDao.getAgency(this.advertiser.agency as any).subscribe(res => {
        //   this.agency = res;
        //   if (this.agency.tradeDeskToken && this.agency.tradeDeskPartnerId && this.isAdmin) {
        //     if (!this.integrations.some(i => i.type === 'trade-desk')) {
        //       this.integrations.push(this.ttdIntegration);
        //     }
        //   }
        //   this.syncIntegrations();
        //   this.filterChange();
        // });
        // this.subs.push(sub);
      } else {
        this.syncIntegrations();
        this.filterChange();
      }
      this.initInvites();
    });
  }

  handleClick(int) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { dialog: int.type }
    });
    let found = this.integrations.find(i => i.type === int.type);
    found.click(found.connectedIntegrations, found.description, found.name, found.type);
  }

  handleManageClick(int: IIntegrationDisplay, click?: boolean) {
    if (!this.onboardingView || click || int.type === 'web_tracking') {
      this.setDialogNavParams(int);
      int.click(int.connectedIntegrations, int.description, int.name, int.type);
    } else {
      this.onManageClick.emit(int);
    }
  }

  setDialogNavParams(int) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { dialog: int.type }
    });
  }

  handleClose() {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {}
    });
  }

  invite(int?) {
    let toEmit = int ? int : undefined;
    this.onInviteClick.emit(toEmit);
  }

  ngOnDestroy(): void {
    this.syncInviteStatus();
    this.subs.forEach(sub => sub.unsubscribe());
  }

  filterChange() {
    if (this.onboardingView) {
      this._availableIntegrations = ['web_tracking', ...this._availableIntegrations];
    }
    this.filteredIntegrations = this.integrations.filter(int => {
      return (int.category === this.category || this.category === '') && this._availableIntegrations.includes(int.type);
    }) as any;
  }

  webTracking(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      user: this.user,
      tag: this.tag,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(TrackingTagComponent, {
      data: data
    });
    this.manageIntegration(ref);
  }

  googleAnalytics(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      user: this.user,
      invites: this.integrationInvites,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(GoogleAnalyticsComponent, {
      data: data
    });
    this.manageIntegration(ref);
  }

  googleAnalyticsReporting(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      user: this.user,
      invites: this.integrationInvites,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(GoogleAnalyticsReportingComponent, {
      data: data,
      autoFocus: false
    });
    this.manageIntegration(ref);
  }

  googleAds(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      user: this.user,
      invites: this.integrationInvites,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(GoogleAdsComponent, {
      data: data
    });
    this.manageIntegration(ref);
  }

  googleAdsReadOnly(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      user: this.user,
      invites: this.integrationInvites,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(GoogleAdsReadOnlyComponent, {
      data: data
    });
    this.manageIntegration(ref);
  }

  facebook(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      user: this.user,
      invites: this.integrationInvites,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(FacebookComponent, {
      data: data
    });
    this.manageIntegration(ref);
  }

  amazon(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      user: this.user,
      invites: this.integrationInvites,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(AmazonComponent, {
      data: data
    });
    this.manageIntegration(ref);
  }

  twitter(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      user: this.user,
      invites: this.integrationInvites,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(TwitterComponent, {
      data: data
    });
    this.manageIntegration(ref);
  }

  snapchat(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      user: this.user,
      invites: this.integrationInvites,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(SnapchatComponent, {
      data: data
    });
    this.manageIntegration(ref);
  }

  bing(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      user: this.user,
      invites: this.integrationInvites,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(BingComponent, {
      data: data
    });
    this.manageIntegration(ref);
  }

  tradeDesk(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      agency: this.agency,
      user: this.user,
      invites: this.integrationInvites,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(TradeDeskComponent, {
      data: data
    });
    this.manageIntegration(ref);
  }

  googleDrive(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      user: this.user,
      invites: this.integrationInvites,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(GoogleDriveComponent, {
      data: data
    });
    this.manageIntegration(ref);
  }

  s3(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      user: this.user,
      invites: this.integrationInvites,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(S3Component, {
      data: data
    });
    this.manageIntegration(ref);
  }

  ftp(existingIntegrations, description, name, type) {
    let data = {
      existingIntegrations,
      description,
      name,
      type,
      brand: this.brand.id,
      user: this.user,
      invites: this.integrationInvites,
      emitter: this.inviteEmitter
    };
    let ref = this.dialog.open(FtpComponent, {
      data: data
    });
    this.manageIntegration(ref);
  }

  manageIntegration(ref) {
    let sub = ref.afterClosed().subscribe(
      res => {
        this.handleClose();
        if (res) {
          let index = this.brand.integrations.findIndex(i => i.id === res.id);
          if (index !== -1) {
            this.brand.integrations.splice(index, 1);
            this.brand.integrations.push(res);
            this.syncIntegrations();
          } else {
            this.brand.integrations.push(res);
            this.syncIntegrations();
          }
        } else {
          this.syncIntegrations();
        }
        this.syncInviteStatus();
      },
      err => console.error(err)
    );
    this.subs.push(sub);
  }

  syncIntegrations() {
    for (let i of this.integrations) {
      i.connectedIntegrations = [];
      if (i.type === 'web_tracking' && this.tag && this.tag.embedDetected) {
        i.connectedIntegrations.push(this.tag);
      }
    }
    if (this.brand) {
      for (let brInt of this.brand.integrations) {
        for (let i of this.integrations) {
          if (brInt.type === 'google_ads') {
            if(i.type === 'google_ads' && brInt.version !== 'readonly' && brInt.enabled) {
              i.connectedIntegrations.push(brInt);
            } else if(i.type === 'google_ads_read_only' && brInt.version === 'readonly' && brInt.enabled) {
              i.connectedIntegrations.push(brInt);
            }
          } else if (brInt.type === i.type && brInt.enabled) {
            i.connectedIntegrations.push(brInt);
          }
        }
      }
    }
  }

  inviteCompleted(invite: IntegrationInvite) {
    let connectedIntegrations = this.brand.integrations.filter(i => i.enabled).map(i => i.type);
    return invite.integrations.every(i => connectedIntegrations.includes(i));
  }

  syncInviteStatus() {
    for (let invite of this.integrationInvites) {
      if (!invite.completed && this.inviteCompleted(invite) && window.location.href.includes('connect-integrations')) {
        let sub = this.inviteDao.markComplete(invite.id).subscribe(
          res => {},
          err => {
            console.error('error updating invite', err);
          }
        );
        this.subs.push(sub);
      }
    }
  }
}
